export default "__VITE_ASSET__DUWMIfwo__"